$.fn.m6Posts = function( $item, $trigger ) {
	$item = typeof $item === 'undefined' ? $(this) : $item;

	var canload = true;

	var deviceAgent = navigator.userAgent.toLowerCase(),
		agentID = deviceAgent.match(/(iphone|ipod|ipad)/);

	if($item.data('event') && $item.data('event') == 'click') {
		$item.find('.more').on('click', function(e) {
			e.preventDefault();
			$item.m6PostsLoader();
			$item.m6GetPosts(function(numpage) {
				canload = numpage;
			});
		});

	} else {
		$(window).on('touchmove', onScroll);
		$(window).on('scroll', onScroll);

		function onScroll() {
			if(!canload) return;

			if($(window).scrollTop() >= $item.offset().top + $item.outerHeight() + 30 - window.innerHeight) {
				canload = false;
				$item.m6PostsLoader();
				$item.m6GetPosts(function(numpage) {
					canload = numpage;
				});
			}
		}
	}
};

$.fn.m6PostsLoader = function() {
	var $loader = $('<div class="loader"></div>');

	$(this).m6PostsAppend($loader);
	$loader.addClass('show');
};

$.fn.m6PostsAppend = function(html) {
	if($(this).find('footer').length > 0) {
		$(this).find('footer').before(html)
	} else {
		$(this).append(html);
	}
}

$.fn.m6PostsParams = function() {
	var params = {};

	$.each($(this)[0].attributes, function(i, attr) {
		if(attr.name == 'data-posts')
			return;

		if (/^data-/.test(attr.name)) {
			var value = isNaN(parseInt(attr.value)) ? attr.value : parseInt(attr.value);
			params[attr.name.substr(5)] = attr.value;
		}
	});

	return params;
};

$.fn.m6GetPosts = function(callback) {
	var $item = $(this),
		$loader = $item.find('.loader');

	var params = $item.m6PostsParams();

	$.get('/wp-json/m6press/v1/posts/', params)
	.done(function(data) {
		$loader.remove();

		$.each(data.suggestions, function(i,e) {
			var html = m6PostCard(e);
			$item.m6PostsAppend(html);
		});

		$(window).lazyLoadXT();
		
		if(params.paged)
			$item.attr('data-paged', parseInt(params.paged)+1);

		if(params.paged == data.max_num_pages)
			$item.find('.more').remove();

		callback(params.paged < data.max_num_pages);
	});
};

var m6PostCard = function( data, col ) {
	if(!data)
		return;

	col = data.data.cols ? ' medium-' + (12/data.data.cols) : ' medium-4';

	var html = '<div class="col' + col + '">';
		html += '<article class="card ' + data.data.object_type + '">';

	var smallThumb = data.data.img.thumbnail_small ? ' data-src-small="' + data.data.img.thumbnail_small + '"' : '';

	if(data.data.url && data.data.img.thumbnail) {
		var alt = data.data.title;
		alt += data.data.subtitle ? ' ' + data.data.subtitle : '';
		html += data.data.noLink == 1 ? '<span' : '<a href="' + data.data.url + '"';
		html += ' class="card_thumbnail"><img data-src="' + data.data.img.thumbnail + '"' + smallThumb + ' alt="' + alt + '">';
		html += data.data.noLink == 1 ? '</span>' : '</a>';
	}
	
	html += '<div class="card_content">';

	if(data.data.terms) {
		for(var i = 0; i < data.data.terms.length; i++)
			html += '<span class="tag">' + data.data.terms[i].name + '</span>';
	}

	html += data.data.url && !data.data.noLink ? '<a href="' + data.data.url + '"' : '<span'
	html += ' class="card_title">' + data.data.title;
	html += data.data.subtitle ? '<span class="card_subtitle">' + data.data.subtitle + '</span>' : '';
	html += data.data.url && !data.data.noLink ? '</a>' : '</span>';

	html += '</div>';
	html += '</article>';
	html += '</div>';

	return html;
};

if($('[data-posts]').length > 0) {
	$('[data-posts]').each(function() {
		$(this).m6Posts();
	});
}
	